export default "__VITE_ASSET__CY4J13Wa__"